import { render, staticRenderFns } from "./CommunityDialog.vue?vue&type=template&id=4bb530f0&scoped=true&"
import script from "./CommunityDialog.vue?vue&type=script&lang=js&"
export * from "./CommunityDialog.vue?vue&type=script&lang=js&"
import style0 from "./CommunityDialog.vue?vue&type=style&index=0&id=4bb530f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb530f0",
  null
  
)

export default component.exports